import React, { useEffect } from 'react';
import { MapContext } from '../../context/MapContext';

const OSRM_URL = process.env.REACT_APP_OSRM_URL || 'https://router.project-osrm.org/route/v1/driving';

export function RouteBuilder() {
    const { points, setRoute, setDistance } = React.useContext(MapContext);

    useEffect(() => {
        if (points.length >= 2) {
            const coords = points
                .map((point) => `${point.longitude},${point.latitude}`)
                .join(';');

            fetch(
                `${OSRM_URL}/${coords}?overview=full&geometries=geojson&steps=false`
            )
                .then((r) => r.json())
                .then((data) => {
                    setRoute(data.routes?.[0]?.geometry ?? null);
                    setDistance(data.routes?.[0]?.distance ?? 0);
                })
                .catch(() => {
                    setRoute(null);
                    setDistance(0);
                });
        } else {
            setRoute(null);
            setDistance(0);
        }
    }, [points]);

    return <></>;
}
